import _ from 'underscore';
import { smoothScrollToElement } from './scroll';

export function onClickAccHandler(opened, id, hash) {
    if (hash != id && !(sectionIsOpen(opened, id))) {
        return [opened, true, true];
    } else if (hash == id && !(sectionIsOpen(opened, id))) {
        opened = toggleSection(opened, id);
        return [opened, false, true];
    } else if (hash == id) {
        opened = toggleSection(opened, id);
        return [opened, false, false];
    }

    return [opened, true, false];
}

export function toggleSection(opened, next) {
    if (sectionIsOpen(opened, next)) {
        return opened.filter(item => item !== next);
    }

    opened.push(next);
    return opened;
}

export function sectionIsOpen(opened, next) {
    return _.contains(opened, next);
}


export function accScroll(chapter, ms) {
    const selector = chapter == 'main' ? 'main' : `#${chapter}`;

    checkElement(selector).then((element) => {
        setTimeout(() => {
            smoothScrollToElement(element);
        }, ms);
    });
}

function rafAsync() {
    return new Promise((resolve) => {
        requestAnimationFrame(resolve);
    });
}

async function checkElement(selector) {
    const element = document.querySelector(selector);

    while (element === null) {
        await rafAsync();
    }

    return element;
}
